import "./App.css";
import {BrowserRouter, Routes, Route}  from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from "./component/Login";
import LogOut from "./component/LogOut";
import Register from "./component/Register";
import User from "./component/UserList";
import Barang from "./component/Barang";
import TambahBarang from "./component/TambahBarang";
import EditBarang from "./component/EditBarang";
import TambahBarangKeluar from "./component/barangkeluar/TambahBarangKeluar";
import BarangMasuk from "./component/barangmasuk/BarangMasukList";
import TambahBarangMasuk from "./component/barangmasuk/TambahBarangMasuk";
import BarangKeluar from "./component/barangkeluar/BarangKeluarList";
import TambahKategori from "./component/kategori/TambahKategori";
import KategoriList from "./component/kategori/KategoriList";
import React from 'react'
// import Navbar from "./component/Navbar";
// import SideBar from "./component/sidebar/Sidebar";

function App() {
  return (
    <BrowserRouter>
    <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Routes>
        <Route path="/login" element={<Login/>}/>
        <Route path="/logout" element={<LogOut/>}/>
        <Route path="/tambahbarang" element={<TambahBarang/>}/>
        <Route path="edit/:id" element={<EditBarang/>}/>
        <Route path="/barangmasuk/tambahbarangmasuk" element={<TambahBarangMasuk/>}/>
        <Route path="/barangkeluar/tambahbarangkeluar" element={<TambahBarangKeluar/>}/>
        <Route path="/kategori/tambahkategori" element={<TambahKategori/>}/>
        <Route path="/users/register" element={<Register/>}/>
        <Route path="/" element={<Barang/>}/>
        <Route path="/users" element={<><User/></>}/>
        <Route path="/barangmasuk" element={<BarangMasuk/>}/>
        <Route path="/barangkeluar" element={<BarangKeluar/>}/>  
        <Route path="/kategori" element={<KategoriList/>}/>
      </Routes>
      {/* <SideBar>
      <Routes>
        <Route path="/" element={<Barang/>}/>
        <Route path="/users" element={<><User/></>}/>
        <Route path="/barangmasuk" element={<BarangMasuk/>}/>
        <Route path="/barangkeluar" element={<BarangKeluar/>}/>  
        <Route path="/kategori" element={<KategoriList/>}/>
      </Routes>
      </SideBar> */}
      
    </BrowserRouter>

  );
}

export default App;
